import { Container as MantineContainer, ContainerProps } from '@mantine/core';
import { forwardRef } from 'react';

export interface ThemedContainerProps extends ContainerProps {
  centered?: boolean;
}

const Container = forwardRef<HTMLDivElement, ThemedContainerProps>(
  ({ centered = false, style, children, ...rest }, ref) => {
    return (
      <MantineContainer
        ref={ref}
        style={{
          ...(centered && {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }),
          ...style,
        }}
        {...rest}
      >
        {children}
      </MantineContainer>
    );
  }
);

Container.displayName = 'Container';

export default Container;
